import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { initializeUserBehaviorMonitoring } from '@tokenbox/services';
import { environment } from './environments/environment.development';

import 'core-js/actual/object/group-by';

// local fix for bug (console error "Unable to preventDefault inside passive event listener invocation." when dragging around the color picker in @iplab/ngx-color-picker):
// see also: https://github.com/angular/angular/issues/45020
document.addEventListener(
  'mousemove',
  () => {
    /* noop */
  },
  {
    passive: false,
    capture: true,
  },
);

if (environment.monitoring.enableMonitoring) {
  initializeUserBehaviorMonitoring(
    'webapp-fe',
    environment.env,
    environment.monitoring.posthog,
  );
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((error: unknown) => {
  console.error(error);
});
